/**
 * Benign Firebase Auth popup/redirect races (e.g. user closes popup early,
 * switches to email signup, or navigates before the SDK settles).
 */
export function isBenignFirebaseAuthPopupError(error: unknown): boolean {
  const code = String((error as { code?: string })?.code || "");
  const message = String(
    (error as { message?: string })?.message || error || ""
  );
  return (
    message.includes("Pending promise was never set") ||
    code === "auth/popup-closed-by-user" ||
    code === "auth/cancelled-popup-request" ||
    code === "auth/popup-blocked"
  );
}
